export type AiCmoFeatureProject =
  | {
      feature_settings?: {
        ai_cmo_beta_enabled?: boolean;
      };
    }
  | null
  | undefined;

export function isAiCmoBetaEnabled(project: AiCmoFeatureProject): boolean {
  return project?.feature_settings?.ai_cmo_beta_enabled === true;
}
